import React from 'react'
import { propTypes, withFormsy } from 'formsy-react'
import { Wrapper, FieldWrapper, FieldName, ErrorMessage } from './FormInput.styles'
import Select from 'react-select'

class SelectInput extends React.Component {
  constructor (props) {
    super(props)
    this.changeValue = this.changeValue.bind(this)
  }

  changeValue (val) {
    this.props.setValue(val && val.value)

    if (this.props.onChange) {
      this.props.onChange(val)
    }
  }

  getErrorMessage () {
    if (!this.props.isFormSubmitted()) return
    if (this.props.isRequired() && !this.props.getValue()) {
      return `${this.props.fieldName || 'This field'} is required`
    }
    return this.props.getErrorMessage()
  }

  render () {
    return (
      <Wrapper>
        <FieldWrapper
          displayStyle={this.props.displayStyle}
          inputWidth={this.props.inputWidth}
        >
          <FieldName color={this.props.fieldNameColor}>
            {this.props.fieldName}
          </FieldName>

        </FieldWrapper>
        <Select
          defaultValue={this.props.value}
          options={this.props.options}
          onChange={this.changeValue}
          wrapperStyle={this.props.wrapperStyle}
        />
      </Wrapper>
    )
  }
}

export default withFormsy(SelectInput)
